import { BaseFirestoreService } from "../FirestoreService";
import { User, USERS_COLLECTION } from "../../db/user";
import { UserPrivateInfosService } from "./UserPrivateInfosService";
import { UserProtectedInfosService } from "./UserProtectedInfosService";
import { UserReviewService } from "./UserReviewService";
import { FirestoreTimestampServerValue } from "../../db/common";

/**
 * Shared User Service
 * Works with both Firebase Admin SDK (backend) and Client SDK (frontend)
 */
export class UserService extends BaseFirestoreService<User> {
    protected getCollectionPath(): string {
        return USERS_COLLECTION;
    }

    public privateInfoService(userId: string) {
        return new UserPrivateInfosService(this.firestore, userId);
    }

    public protectedInfoService(userId: string) {
        return new UserProtectedInfosService(this.firestore, userId);
    }

    public reviewService(userId: string) {
        return new UserReviewService(this.firestore, userId);
    }

    create(data: Omit<User, 'id' | 'forums' | 'join_date' | 'last_active_date' | 'is_verified' | 'verifications' | 'languages' | 'isDirectChatAllowed'>, id?: string): Promise<string> {
        return super.create({
            //initialize to default
            id: id || '',
            forums: {
                posts_count: 0,
                replies_count: 0,
                likes_count: 0,
                replied_count: 0,
                liked_count: 0,
            },
            join_date: FirestoreTimestampServerValue,
            last_active_date: FirestoreTimestampServerValue,
            is_verified: false,
            verifications: [],
            languages: [],
            isDirectChatAllowed: true,
            //can be overwrited if provided in data
            ...data,
        }, id)
    }
}
